import { useState } from 'react'
import { Topbar } from '../../components/Topbar.js'
import { Tab, TabList } from '../../ui/index.js'
import { usePageTitle } from '../../lib/page-title.js'
import { DepartmentsTab } from './DepartmentsTab.js'
import { PeopleTab } from './PeopleTab.js'
import { OrganisationTab } from './OrganisationTab.js'

type AdminTabId = 'departments' | 'people' | 'organisation'

export function Admin() {
  usePageTitle('Admin')
  const [tab, setTab] = useState<AdminTabId>('departments')

  return (
    <>
      <Topbar title="Admin" eyebrow="Organisation settings" />
      <div style={{ padding: 'var(--o-space-4)' }}>
        <TabList activeTabId={tab} onTabChange={(id) => setTab(id as AdminTabId)}>
          <Tab id="departments">Departments</Tab>
          <Tab id="people">People</Tab>
          <Tab id="organisation">Organisation</Tab>
        </TabList>

        <div style={{ marginTop: 'var(--o-space-4)' }}>
          {tab === 'departments' ? <DepartmentsTab /> : null}
          {tab === 'people' ? <PeopleTab /> : null}
          {tab === 'organisation' ? <OrganisationTab /> : null}
        </div>
      </div>
    </>
  )
}
